export default __webpack_public_path__ + "static/media/face_2_65.1cc74193.png";